import { Blocs } from '@business/blocs';
import { PayablesInvoiceItemSearchParams, TMProviderInvoiceItemDetailedResponse } from '@business/entities/tm/TMProviderInvoiceResponse';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { PaginatedController } from '@core/utils/paginated';
import { LoadingState } from '@core/utils/repository/loading_state';
import { forkJoin } from 'rxjs';

export const PAYABLES_LIST_INITIAL_QUERY: PayablesInvoiceItemSearchParams = {
  page: 1,
  search: '',
  isDetailed: true,
  providerId: null,
  paymentTypeStatus: 'all',
};

export class PayablesListBloc extends BaseBloc {
  private readonly invoiceItemBloc = resolve(Blocs.tmProviderInvoiceItem);
  private readonly tmServiceProviderBloc = resolve(Blocs.tmServiceProvider);

  loading = new LoadingState();

  providers$ = this.tmServiceProviderBloc.items$;

  onInit() {
    return forkJoin([this.paginated.fetch().pipe(this.loading.run()), this.tmServiceProviderBloc.fetchServiceProviders()]);
  }

  fetchInvoiceItems = (query?: any) => {
    return this.invoiceItemBloc.fetchInvoiceItems(query).pipe(this.loading.run({}));
  };

  readonly paginated = new PaginatedController<TMProviderInvoiceItemDetailedResponse, string, PayablesInvoiceItemSearchParams>(
    this.fetchInvoiceItems,
    '',
    PAYABLES_LIST_INITIAL_QUERY,
  );

  readonly items$ = this.paginated.items$;
  readonly query$ = this.paginated.pageQuery$;
}
